export enum InvitationType {
  Regular = 'REGULAR',
  OneTime = 'ONE_TIME',
  OneTimeEntry = 'ONE_TIME_ENTRY',
}
